<template>
    <div class="car pr" v-if="swiperData.length > 1">
        <el-divider>同类商品</el-divider>
        <!-- 第二个swiper -->
        <div class="swiper2 swiper-no-swiping">
            <swiper :options="swiperOption2" >
                <swiper-slide v-for="item in swiperData" :key="item.goods_id" class="pr" @click.native="gotoDetail(item)">
                    <img :src="item.original_img | thumbnailUrl"/>
                    <div class="remarks">
                        <div>{{ item.goods_name }}</div>
                        <div>{{ item.goods_spec }}</div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <div class="swiper-button-prev"></div>
        <!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
        <div class="swiper-button-next"></div>
        <!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
    </div>
</template>

<!-- 组件的模型 -->
<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    export default {
        // 组件的名称
        name: "car",
        props: ["swiperData"],
        data() {
            return {
                swiperOption2:{
                    direction: 'vertical',
                    slidesPerView: '3',
                    loop: true,
                    autoplayDisableOnInteraction:false,
                    autoplay:false,
                    mousewheel: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                }
            }
        },
        components: {
            swiper,
            swiperSlide,
        },
        methods: {
            gotoDetail(val) {
                this.$router.push(`/goodDetail/${val.goods_id}`);
            }
        }
    }
</script>

<!-- 组件的样式 -->
<style scoped>
    .title{
        font-size: 15px;
        height: 45px;
        line-height: 45px;
        font-weight: 700;
        text-align: center;
        color: #444;
    }
    .swiper2{
        width: 200px;
        height: 450px;
    }
    .swiper2 .swiper-container{
        height: 100%;
    }
    .swiper2 .swiper-slide{
        height: 100px;
        line-height: 133px;
    }
    img{
        width: 120px;
        line-height: 133px;
        object-fit: contain;
        cursor:pointer;
        display: inline-block;
        vertical-align: middle;
        margin-left: 45px;
    }
    .remarks{
        width: 100%;
        height: 30px;
        opacity: 0.7;
        text-align: center;
        position: absolute;
        bottom: 0;
        margin-top: 10px;
    }
    .remarks div{
        height: 15px;
        line-height: 15px;
    }
    .swiper-button-prev{
        outline: none;
        bottom: 460px;
        left: 90px;
        width: 20px;
        height: 20px;
        background-size: 20px 20px;
        top: inherit;
        position: absolute;
        transform:rotate(90deg);
    }
    .swiper-button-next{
        outline: none;
        bottom: -20px;
        right: 90px;
        width: 20px;
        height: 20px;
        background-size: 20px 20px;
        top: inherit;
        position: absolute;
        transform: rotate(90deg);
    }
</style>